// extracted by mini-css-extract-plugin
export var aboveInput = "_ft-0";
export var actionButton = "_ft-5";
export var actionButtonContainer = "_ft-1";
export var actionIcon = "_ft-6";
export var aiInfoContainer = "_ft-2";
export var attachmentWrapper = "_ft-7";
export var bold = "_ft-3";
export var checkIcon = "_ft-8";
export var clickingRecipientBar = "_ft-11";
export var commentThreadSwitch = "_ft-a";
export var draftImage = "_ft-b";
export var draftImageContainer = "_ft-c";
export var draftImages = "_ft-e";
export var editButton = "_ft-g";
export var editor = "_ft-f";
export var editorContainer = "_ft-y";
export var editorErrorTooltipWrapper = "_ft-9";
export var headerDivider = "_ft-h";
export var icon = "_ft-i";
export var info = "_ft-j";
export var internal = "_ft-n";
export var internalDivider = "_ft-k";
export var internalMessage = "_ft-l";
export var messageInputCard = "_ft-m";
export var messageInputForm = "_ft-o";
export var messageInputFormInternal = "_ft-p";
export var options = "_ft-q";
export var publicMessageCustomer = "_ft-s";
export var publicMessageMerchant = "_ft-r";
export var removeImageButton = "_ft-d";
export var replyButtons = "_ft-t";
export var showSignatureButton = "_ft-u";
export var spinner = "_ft-v";
export var verticalButtonDivider = "_ft-4";
export var visibilitySelector = "_ft-w";
export var warning = "_ft-x";
export var wrappingText = "_ft-z";
export var writingInternalNoteTopBorder = "_ft-10";